import BatteryIcon from "@assets/icons/battery.svg";
import styles from "./battery.module.scss";

type Props = { battery: number };

export const Battery = ({ battery }: Props) => {
  return (
    <div className={styles.batteryContainer}>
      <BatteryIcon />
      <span className={styles.battery}>{battery}%</span>
    </div>
  );
};
